<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ gameName }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.mode) }}
        game-preview-setting(v-if="parameters.textLabel")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_textLabel') }}
            span(slot="value") {{ parameters.textLabel }}
        game-preview-setting(v-if="parameters.settings.allQuestions")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_allQuestions') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.settings.endLetters")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_withoutEndLetters') }}
            span(slot="value") {{ parameters.settings.letters }}
        game-preview-setting(v-if="parameters.settings.centralLetters")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_withoutCentralLetters') }}
            span(slot="value") {{ parameters.settings.letters }}
        game-preview-setting(v-if="parameters.settings.withoutWord")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_withoutWord') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.settings.anagrams")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfAnagrams') }}
            span(slot="value") {{ parameters.settings.anagrams.label }}
        game-preview-setting(v-if="parameters.withTime && parameters.settings.words")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWords') }}
            span(slot="value") {{ parameters.settings.words }}
        game-preview-setting(v-if="parameters.settings.mirrorText")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSettings_amountOfMirrorWords') }}
            span(slot="value") {{ parameters.settings.mirrorText.label }}
        game-preview-setting(v-if="parameters.settings.invertText")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_invertText') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.settings.withoutVowels")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_withoutVowels') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.settings.solidText")
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_solidText') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
        game-preview-setting(v-if="parameters.withTime")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}
            span(slot="value") {{ parameters.speed.value }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_metronome') }}
            span(slot="value") {{ formattedBPM }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            gameName () {
                return this.$i18n.t('common.common_gameName_texts');
            },
            intervalName () {
                return this.parameters.mode === 'appear' ? 0 : 1;
            },
            formattedBPM () {
                return this.parameters.metronomeSpeed
                        ? `${this.parameters.metronomeSpeed} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_bpm')
                        : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated')
            }
        }
    }
</script>
